var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___dVh2NC",
  "yF": "AutocompleteEmoji.module__divider___dVh2NC",
  "mI": "AutocompleteEmoji.module__emojiIcon___dVh2NC",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___dVh2NC",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___dVh2NC",
  "lA": "AutocompleteEmoji.module__stickerIcon___dVh2NC",
  "Cu": "AutocompleteEmoji.module__memeIcon___dVh2NC",
  "_Q": "AutocompleteEmoji.module__memeVideo___dVh2NC",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___dVh2NC",
  "iw": "AutocompleteEmoji.module__audioIcon___dVh2NC",
};

module.exports = exports;
